module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pageLoading),
      expression: "pageLoading"
    }],
    staticClass: "bind-wrapper"
  }, [_c('div', {
    staticClass: "acConnect"
  }, [(!_vm.successfullyBound && !_vm.applyUnbinding) ? [_c('app-logo', {
    attrs: {
      "app-name": _vm.bindInfo.app_name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "acConnect__text"
  }, [_c('h1', {
    staticClass: "acConnect__text-title"
  }, [_vm._v(_vm._s(_vm.$t('thirdPartyLogin.successfulLogin')))]), _vm._v(" "), _c('p', {
    staticClass: "acConnect__text-descr"
  }, [_vm._v("\n          " + _vm._s(_vm.$t(("thirdPartyLogin." + (_vm.isForceWeixinLogin ? 'needWeChat' : 'recommendWeChat')), {
    app: _vm.bindInfo.app_name
  })) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "acConnect__btns"
  }, [_c('el-button', {
    staticClass: "acConnect__btns-item",
    attrs: {
      "size": "medium",
      "loading": _vm.binding,
      "type": "primary"
    },
    on: {
      "click": _vm.toBindWx
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isMiniprogram ? _vm.$t('thirdPartyLogin.bind') : _vm.$t('thirdPartyLogin.completeBinding')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "acConnect__btns-cancel"
  }, [(_vm.isMiniprogram) ? _c('el-button', {
    staticClass: "acConnect__btns-item",
    attrs: {
      "size": "medium",
      "disabled": _vm.binding,
      "plain": ""
    },
    on: {
      "click": _vm.toLoginPage
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cancel')))]) : _c('el-button', {
    staticClass: "acConnect__btns-item",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.toReturnUrl
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isForceWeixinLogin ? _vm.$t('thirdPartyLogin.logout') : _vm.$t('thirdPartyLogin.doNotRemindAgain')) + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "acConnect__btns-cancelDescr"
  }, [_vm._v(_vm._s(_vm.$t('thirdPartyLogin.unbindPrompt')))])], 1)], 1)] : (_vm.applyUnbinding) ? [_c('app-logo', {
    attrs: {
      "app-state": _vm.logo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "acConnect__text"
  }, [_c('h1', {
    staticClass: "acConnect__text-title"
  }, [_vm._v("\n          " + _vm._s(_vm.logo === 'warning' ? _vm.$t('thirdPartyLogin.applyForUnbinding') : _vm.$t('thirdPartyLogin.submittedUnbinding')) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "acConnect__text-descr"
  }, [(_vm.logo === 'warning') ? [_vm._v("\n            " + _vm._s(_vm.$t('thirdPartyLogin.isUnbindWeChat')) + "\n            "), _c('div', [_vm._v(_vm._s(_vm.$t('thirdPartyLogin.willNotLoginWithWeChat')))])] : [_vm._v("\n            " + _vm._s(_vm.$t('thirdPartyLogin.unbindingDesc')) + "\n            "), _c('div', [_vm._v(_vm._s(_vm.$t('thirdPartyLogin.enterApp', {
    time: _vm.time
  })))])]], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.unbindLoading && _vm.logo === 'warning'),
      expression: "unbindLoading && logo === 'warning'"
    }],
    staticClass: "acConnect__btns"
  }, [(_vm.logo === 'warning') ? _c('el-button', {
    staticClass: "acConnect__btns-item",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.toReturnUrl
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.cancel')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "acConnect__btns-cancel"
  }, [(_vm.logo === 'warning') ? _c('el-button', {
    staticClass: "acConnect__btns-item",
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": _vm.unbindAccount
    }
  }, [_vm._v(_vm._s(_vm.$t('thirdPartyLogin.unbind')))]) : _c('el-button', {
    staticClass: "acConnect__btns-item",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.enterApp
    }
  }, [_vm._v(_vm._s(_vm.$t('thirdPartyLogin.backHome')))])], 1)], 1)] : [_c('app-logo', {
    attrs: {
      "app-state": 'success'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "acConnect__text"
  }, [_c('h1', {
    staticClass: "acConnect__text-title"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('thirdPartyLogin.bindSuccessfully')) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "acConnect__text-descr"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('thirdPartyLogin.boundDescription', {
    username: _vm.bindInfo.username,
    weixin: _vm.getNickname()
  })) + "\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.$t('thirdPartyLogin.enterApp', {
    time: _vm.time
  })) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "acConnect__btns"
  }, [_c('el-button', {
    staticClass: "acConnect__btns-item",
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.enterApp
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('thirdPartyLogin.enterImmediately')) + "\n        ")])], 1)]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84be4a76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BindWeixin.vue
// module id = 393
// module chunks = 1